

import {
    List,
    Map as MapIcon,
    Add as Plus,
    Close as X
} from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';



import type { TimelineFilters } from '@/lib/timeline-utils';

interface TimelineHeaderProps {
  filters: TimelineFilters;
  onClearFilters: () => void;
  onQuickCreate: () => void;
  viewMode: 'list' | 'map';
  onViewModeChange: (_: React.MouseEvent<HTMLElement>, mode: 'list' | 'map' | null) => void;
}

export function TimelineHeader({
  filters,
  onClearFilters,
  onQuickCreate,
  viewMode,
  onViewModeChange,
}: TimelineHeaderProps) {
  const { t } = useTranslation();
  const activeFilterCount =
    filters.locationIds.length +
    filters.characterIds.length +
    filters.organizationIds.length +
    filters.narrativeStatus.length +
    (filters.dateRange ? 1 : 0);

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        p: 2,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
        {/* View Toggle */}
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={onViewModeChange}
          size="small"
        >
          <ToggleButton value="list">
            <List sx={{ fontSize: 18, mr: 1 }} />
            {t('timeline.header.list')}
          </ToggleButton>
          <ToggleButton value="map">
            <MapIcon sx={{ fontSize: 18, mr: 1 }} />
            {t('timeline.header.map')}
          </ToggleButton>
        </ToggleButtonGroup>

        {/* Quick Create Button */}
        <Button
          variant="contained"
          startIcon={<Plus sx={{ fontSize: 18 }} />}
          onClick={onQuickCreate}
          sx={{ ml: 'auto' }}
        >
          {t('timeline.header.event')}
        </Button>
      </Stack>

      {/* Active Filter Chips */}
      {activeFilterCount > 0 && (
        <Stack direction="row" spacing={1} sx={{ mt: 2 }} flexWrap="wrap">
          <Chip
            label={t(activeFilterCount > 1 ? 'timeline.header.filter_active_other' : 'timeline.header.filter_active_one', { count: activeFilterCount })}
            size="small"
            onDelete={onClearFilters}
            deleteIcon={<X sx={{ fontSize: 14 }} />}
          />
        </Stack>
      )}

    </Box>
  );
}
